import axiosCommon from '../helper/axiosCommon'
import qs from 'qs'


async function updateOne(configuredPart) {
  const req = axiosCommon.getAxiosParamsAuth(`/configured-parts/${configuredPart.id}`, 'put', configuredPart)
  return await axiosCommon.axiosRequest(req)
}

async function deleteOne(id) {
  const req = axiosCommon.getAxiosParamsAuth(`/configured-parts/${id}`, 'delete')
  return await axiosCommon.axiosRequest(req)
}

async function createOne(configuredPart) {
  const req = axiosCommon.getAxiosParamsAuth('/configured-parts', 'post', configuredPart)
  return await axiosCommon.axiosRequest(req)
}

async function readPaginated(query) {
  const req = axiosCommon.getAxiosParamsAuth('/configured-parts?' + qs.stringify(query), 'get')
  return await axiosCommon.axiosRequest(req)
}


export default {
  updateOne,
  deleteOne,
  createOne,
  readPaginated,
}


